import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getTrackerAccess } from '../../../../../redux/features/tutorReplacementTrackerSlice';

const EMPTY = { loaded: false, isTaWing: false, isHead: false, canAssign: false, team: [], projects: [] };
// The entry redirect and the page it opens both need access, so one request serves both (and any revisit) for a while
const CACHE_MS = 5 * 60 * 1000;
let cache = null; // { promise, at, cred }

// the login the cached access belongs to, so signing in as someone else never reuses it
const currentCred = () => {
  try {
    return localStorage.getItem('cred') || '';
  } catch {
    return '';
  }
};

const loadAccess = (dispatch) => {
  const cred = currentCred();
  if (cache && cache.cred === cred && Date.now() - cache.at < CACHE_MS) return cache.promise;
  const promise = dispatch(getTrackerAccess()).then((action) => {
    const ok = action.payload?.status === 'success';
    if (!ok && cache?.promise === promise) cache = null; // don't keep a failure around
    return { ...EMPTY, ...(ok ? action.payload.data : {}), loaded: true };
  });
  cache = { promise, at: Date.now(), cred };
  return promise;
};

// { loaded, isTaWing, isHead, canAssign, team, projects } for the signed-in user, from GET /tutor-replacement-tracker/access
export default function useTrackerAccess() {
  const dispatch = useDispatch();
  const [access, setAccess] = useState(EMPTY);

  useEffect(() => {
    let active = true;
    loadAccess(dispatch).then((value) => {
      if (active) setAccess(value);
    });
    return () => {
      active = false;
    };
  }, [dispatch]);

  return access;
}
